import backlinkApi from './backlinkNewApi';

export const backlinkOverviewApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getNumOfBacklink: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_backlink',
        method: 'POST',
        body: body
      })
    }),
    getNumOfDomains: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_domain',
        method: 'POST',
        body: body
      })
    }),
    getNumOfFollowNoFollow: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_follow_no_follow',
        method: 'POST',
        body: body
      })
    }),
    getNumOfAnchorTextTypes: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_anchor_text_types',
        method: 'POST',
        body: body
      })
    }),
    getNumOfReferralDomainsCountryName: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_referral_domains_country_name',
        method: 'POST',
        body: body
      })
    }),
    getNumOfReferralDomainsTldHostName: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/num_of_referral_domains_tld_host_name',
        method: 'POST',
        body: body
      })
    }),
    getMozDomainAuthority: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/moz_domain_authotity',
        method: 'POST',
        body: body
      })
    }),
    getMozSpamScore: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/chart/moz_spam_score',
        method: 'POST',
        body: body
      })
    }),
    getReferralDomainsAndNumOfLinks: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/referral_domains_and_num_of_links',
        method: 'POST',
        body: body
      })
    }),
    getAnchorTextsAndNumOfLinks: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/anchor_texts_and_num_of_links',
        method: 'POST',
        body: body
      })
    }),
    getPagesAndNumOfLinks: build.query({
      query: body => ({
        url: '/api_backlink/v1/overview/pages_and_num_of_links',
        method: 'POST',
        body: body
      })
    })
  })
});
export const {
  useGetNumOfBacklinkQuery,
  useGetNumOfDomainsQuery,
  useGetNumOfFollowNoFollowQuery,
  useGetAnchorTextsAndNumOfLinksQuery,
  useGetMozDomainAuthorityQuery,
  useGetNumOfReferralDomainsCountryNameQuery,
  useGetNumOfReferralDomainsTldHostNameQuery,
  useGetPagesAndNumOfLinksQuery,
  useGetReferralDomainsAndNumOfLinksQuery,
  useGetNumOfAnchorTextTypesQuery,
  useGetMozSpamScoreQuery
} = backlinkOverviewApi;
export default backlinkOverviewApi;
